module.exports = __webpack_public_path__ + "img/fi-korean-food-150x150.10464d81.jpg";